const mutations = {
  SET_CURRENT_USER(state, data) {
    state.currentUser = data;
  },
  CLEAR_CURRENT_USER(state) {
    state.currentUser = {};
  }
  // SET_SIGNIN_ERROR(state, data) {
  //   state.signinError = data;
  // }
};

export default mutations;
